import { NgClass } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import { CheckoutConfirmationComponentDef } from '@df/checkout/checkout-confirmation.component.def';
import { App } from '@df/core/app';
import { Logger } from '@df/core/service/logger';
import { ScrollToErrorService } from '@df/ui/form/scroll-to-error.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { CheckoutFormComponent } from './checkout-form.component';

@Component({
    selector: 'checkout-confirmation',
    templateUrl: './checkout-confirmation.html',
    standalone: true,
    imports: [NgClass, TranslatePipe]
})
export class CheckoutConfirmationComponent extends CheckoutConfirmationComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        ngEl: ElementRef,
        app: App,
        logger: Logger,
        scrollToErrorService: ScrollToErrorService
    ) {
        super(checkoutFormComponent, ngEl, app, logger, scrollToErrorService);
    }
}
